/// <reference path='lib/aos.js' />
/// <reference path='lib/jarallax.js' />
/// <reference path='lib/jarallax-element.js' />
/// <reference path='lib/slick.js' />
/// <reference path='lib/jquery.appear.min.js' />
/// <reference path='lib/jquery.countTo.js' />
/// <reference path='lib/isotope.pkgd.js' />
/// <reference path='lib/jquery.fancybox.js' />

(function($) {

	/*-- Strict mode enabled --*/
	'use strict';

	var nHtmlNode = document.documentElement,
		nBodyNode = document.body || document.getElementsByTagName('body')[0],

		jWindow   = $(window),
		jBodyNode = $(nBodyNode),

		rAF = window.requestAnimationFrame ||
			  window.mozRequestAnimationFrame ||
			  window.webkitRequestAnimationFrame ||
			  window.msRequestAnimationFrame||
			  function (callback) {
				  setTimeout(callback, 1000 / 60);
			  };

	/* LazyLoad
	================================================== */
	// var myLazyLoad = new LazyLoad({
	// 	elements_selector: ".lazy",
	// 	data_src: 'src',
	// 	data_srcset: 'srcset',
	// 	threshold: 500,
	// 	callback_enter: function (element) {

	// 	},
	// 	callback_load: function (element) {
	// 		element.removeAttribute('data-src');

	// 		oTimeout = setTimeout(function ()
	// 		{
	// 			clearTimeout(oTimeout);

	// 			AOS.refresh();

	// 			console.log('refresh')
	// 		}, 1000);
	// 	},
	// 	callback_set: function (element) {
			
	// 	},
	// 	callback_error: function(element) {
	// 		element.src = "https://placeholdit.imgix.net/~text?txtsize=21&txt=Image%20not%20load&w=200&h=200";
	// 	}
	// });

	/* scroll animate
	================================================== */
	AOS.init({
		offset: 120,
		delay: 100,
		duration: 450, // or 200, 250, 300, 350.....
		easing: 'ease-in-out-quad',
		once: true,
		disable: 'mobile'
	});

	/* header
	================================================== */
	function _header ()
	{
		var nHeader      = document.getElementById('top-bar'),
			nMenu        = document.getElementById('top-bar__navigation'),
			nMenuToggler = document.getElementById('top-bar__navigation-toggler'),

			jHeader      = $(nHeader),
			jMenu        = $(nMenu),
			jMenuToggler = $(nMenuToggler),

			jLink        = jMenu.find('li a'),
			jSubmenu     = jMenu.find('.submenu');

		if ( jSubmenu.length > 0 )
		{
			jSubmenu.parent('li').addClass('has-submenu');
		};

		jMenuToggler.on('touchend click', function (e) {
			e.preventDefault();

			var $this = $(this);

			$this.toggleClass('is-active');
			jHeader.toggleClass('is-expanded');

			if ( $this.hasClass('is-active') )
			{
				nHtmlNode.style.overflow = 'hidden';
			}
			else
			{
				nHtmlNode.style.overflow = '';
			}

			return false;
		});

		jLink.on('touchend click', function (e) {

			var $this = $(this),
				$parent = $this.parent();

			if ( jMenuToggler.is(':visible') && $this.next(jSubmenu).length )
			{
				if ( $this.next().is(':visible') )
				{
					$parent.removeClass('drop_active');
					$this.next().slideUp('fast');

				} else {

					$this.closest('ul').find('li').removeClass('drop_active');
					$this.closest('ul').find('.submenu').slideUp('fast');
					$parent.addClass('drop_active');
					$this.next().slideDown('fast');
				};

				return false;
			};
		});

		jWindow.smartresize(function() {

			if ( window.innerWidth >= 991 )
			{
				jHeader.removeClass('is-expanded');
				jMenuToggler.removeClass('is-active');
				jSubmenu.removeAttr('style');
				nHtmlNode.style.overflow = '';
			}
		});
	}

	/* parallax
	================================================== */
	function _parallax ()
	{
		if ( device.desktop() )
		{
			var el = document.querySelectorAll('.jarallax');

			jarallax(el, {
				type: 'scroll', // scroll, scale, opacity, scroll-opacity, scale-opacity
				zIndex: -20,
				onScroll: function(calculations) {
					// console.log(calculations);
				},
				// elementInViewport: $(this),
				onInit: function() {

				},
				onDestroy: function() {

				},
				onCoverImage: function() {

				}
			});
		};
	};

	/* isotope sorting
	================================================== */
	function _gallery_sorting ()
	{
		var nOptionSets = document.getElementById('gallery-set'),
			jOptionSets = $(nOptionSets);

		if ( jOptionSets.length > 0 )
		{
			var jIsoContainer = $('.js-isotope'),
				jOptionLinks = jOptionSets.find('a');

			jOptionLinks.on('click', function(e) {
				var $this = $(this),
					currentOption = $this.data('cat');

				jOptionSets.find('.selected').removeClass('selected');
				$this.addClass('selected');

				if (currentOption !== '*') {
					currentOption = '.' + currentOption;
				}

				jIsoContainer.isotope({filter : currentOption});

				return false;
			});
		};
	};

	/* slick slider
	================================================== */
	function _slickSlider ()
	{
		var slider = $('.js-slick');

		if ( slider.length > 0 )
		{
			slider.each(function (index) {
				var _this = $(this);

				_this.on('init', function(event, slick){

				}).slick({
					autoplay: true,
					autoplaySpeed: 3000,
					adaptiveHeight: true,
					dots: true,
					arrows: false,
					speed: 800,
					mobileFirst: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					prevArrow: '<i class="fontello-left-open slick-prev"></i>',
					nextArrow: '<i class="fontello-right-open slick-next"></i>'
				});
			});
		};
	};

	/* lightbox
	================================================== */
	function _fancybox ()
	{
		var galleryElement = $("a[data-fancybox]");

		if ( galleryElement.length > 0 )
		{
			$("[data-fancybox]").fancybox({
				buttons : [
					'slideShow',
					'fullScreen',
					'thumbs',
					// 'share',
					//'download',
					//'zoom',
					'close'
				],
				loop : true,
				protect: true,
				wheel : false,
				transitionEffect : "tube"
			});
		}
	};

	/* accordion
	================================================== */
	function _accordion ()
	{
		var oAccordion = $('.accordion-container');

		if ( oAccordion.length > 0 ) {

			var oAccItem    = oAccordion.find('.accordion-item'),
				oAccTrigger = oAccordion.find('.accordion-toggler');

			oAccordion.each(function () {
				$(this).find('.accordion-item:eq(0)').addClass('active');
			});

			oAccTrigger.on('click', function (j) {
				j.preventDefault();

				var $this = $(this),
					parent = $this.parent(),
					dropDown = $this.next('article');

				parent.toggleClass('active').siblings(oAccItem).removeClass('active').find('article').not(dropDown).slideUp();

				dropDown.stop(false, true).slideToggle();

				return false;
			});
		};
	};

	/* tabs
	================================================== */
	function _tabs ()
	{
		var oTab = $('.tab-container');

		if ( oTab.length > 0 ) {

			var oTabTrigger = oTab.find('nav a');

			oTab.each(function () {

				$(this)
					.find('nav a:eq(0)').addClass('active').end()
					.find('.tab-content__item:eq(0)').addClass('is-visible');
			});

			oTabTrigger.on('click', function (g) {
				g.preventDefault();

				var $this = $(this),
					index = $this.index(),
					parent = $this.closest('.tab-container');

				$this.addClass('active').siblings(oTabTrigger).removeClass('active');

				parent
					.find('.tab-content__item.is-visible').removeClass('is-visible').end()
					.find('.tab-content__item:eq(' + index + ')').addClass('is-visible');

				return false;
			});
		};
	};

	/* counters
	================================================== */
	function _counters ()
	{
		var counter = $('.js-count');

		function _countInit() {
			counter.each(function() {
				var $this = $(this);

				if( $this.is_on_screen() && !$this.hasClass('animate') )
				{
					$this
						.addClass('animate')
						.countTo({
							from: 0,
							speed: 2000,
							refreshInterval: 100
						});
				};
			});
		};

		if ( counter.length > 0 )
		{
			_countInit();

			jWindow.on('scroll', function(e) {

				// _countInit();

				if( rAF ) {
					rAF(function(){
						_countInit();
					});
				} else {
					_countInit();
				}
			});
		};
	};

	/* google map
	================================================== */
	function _g_map ()
	{
		var maps = $('.g_map');

		if ( maps.length > 0 )
		{
			var apiKey = maps.attr('data-api-key'),
				apiURL;

			if (apiKey)
			{
				apiURL = 'http://maps.google.com/maps/api/js?key='+ apiKey +' &sensor=false';
			}
			else
			{
				apiURL = 'http://maps.google.com/maps/api/js?sensor=false';
			}

			$.getScript( apiURL , function( data, textStatus, jqxhr ) {

				maps.each(function() {
					var current_map = $(this),
						latlng = new google.maps.LatLng(current_map.attr('data-longitude'), current_map.attr('data-latitude')),
						point = current_map.attr('data-marker'),

						myOptions = {
							zoom: 14,
							center: latlng,
							mapTypeId: google.maps.MapTypeId.ROADMAP,
							mapTypeControl: false,
							scrollwheel: false,
							draggable: true,
							panControl: false,
							zoomControl: false,
							disableDefaultUI: true
						},

						stylez = [
							{
								featureType: "all",
								elementType: "all",
								stylers: [
									{ saturation: -100 } // <-- THIS
								]
							}
						];

					var map = new google.maps.Map(current_map[0], myOptions);

					var mapType = new google.maps.StyledMapType(stylez, { name:"Grayscale" });
					map.mapTypes.set('Grayscale', mapType);
					map.setMapTypeId('Grayscale');

					var marker = new google.maps.Marker({
						map: map,
						icon: {
							size: new google.maps.Size(59,69),
							origin: new google.maps.Point(0,0),
							anchor: new google.maps.Point(0,69),
							url: point
						},
						position: latlng
					});

					google.maps.event.addDomListener(window, "resize", function() {
						var center = map.getCenter();
						google.maps.event.trigger(map, "resize");
						map.setCenter(center);
					});
				});
			});
		};
	};

	/* scrollTo
	================================================== */
	function _scrollTo ()
	{
		var Link = $('a[href*="#"]').not('[href="#"]').not('[href="#0"]');

		Link.on('touchend click', function (e) {
			var $this = $(this),
				_offset = 135;

			if ( location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname )
			{
				var target = $(this.hash);

				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

				if ( target.length )
				{
					$('html,body').stop().animate({
						scrollTop: target.offset().top - _offset
					}, 1000);
				}

				return false;
			};
		});
	};

	/* scroll to top
	================================================== */
	function _scrollTop ()
	{
		var	nBtnToTopWrap = document.getElementById('btn-to-top-wrap'),
			jBtnToTopWrap = $(nBtnToTopWrap);

		if ( jBtnToTopWrap.length > 0 )
		{
			var nBtnToTop = document.getElementById('btn-to-top'),
				jBtnToTop = $(nBtnToTop);

			jBtnToTop.on('click', function (e) {
				e.preventDefault();

				$('body,html').stop().animate({ scrollTop: 0 } , 1500);

				return false;
			});

			jWindow.on('scroll', function(e) {

				if ( jWindow.scrollTop() > jBtnToTop.data('visible-offset') )
				{
					if ( jBtnToTopWrap.is(":hidden") )
					{
						jBtnToTopWrap.fadeIn();
					};

				}
				else
				{
					if ( jBtnToTopWrap.is(":visible") )
					{
						jBtnToTopWrap.fadeOut();
					};
				};
			});
		};
	};

	/* contact form
	================================================== */
	function _contactForm ()
	{
		var jForm = $('.js-contact-form');

		if ( jForm.length > 0 )
		{
			jForm.each(function () {
				var $this =$(this);

				$this.on('submit', function() {
					var $this = $(this),
						str = $this.serialize(),
						note = $this.find('.form__note');

					$.ajax({
						type: "POST",
						url: "send_mail/contact_process.php",
						data: str,
						success: function(msg) {

							var result = '<span style="color: green"><br/>Your message has been sent. Thank you!</span>';

							note.html(result);

							$this.get(0).reset();

							setTimeout(function() { note.html('') }, 3000);
						},
						error: function(err) {
							var result = '<span style="color: red"><br/>Your message not sent! Error: "'+err.responseJSON.message+'"</span>';

							note.html(result);
						},
						complete: function() {
						}
					});

					return false;
				});
			});
		};
	};

	$(document).ready(function() {

		/* header
		================================================== */
		_header();

		/* parallax
		================================================== */
		_parallax();

		/* isotope sorting
		================================================== */
		_gallery_sorting();

		/* slick slider
		================================================== */
		_slickSlider();

		/* lightbox
		================================================== */
		_fancybox();

		/* accordion
		================================================== */
		_accordion();

		/* tabs
		================================================== */
		_tabs();

		/* counters
		================================================== */
		_counters();

		/* scrollTo
		================================================== */
		_scrollTo();

		/* scroll to top
		================================================== */
		_scrollTop();

		/* contact form
		================================================== */
		_contactForm();
	});

	jWindow.on('load', function () {

		var jMasonry = $('.js-masonry');

		if ( jMasonry.length > 0 )
		{
			jMasonry.masonry('layout')
		}

		/* google map
		================================================== */
		_g_map();
	});

	$.fn.is_on_screen = function () {
		var viewport = {
			top: jWindow.scrollTop(),
			left: jWindow.scrollLeft()
		};
		viewport.right = viewport.left + jWindow.width();
		viewport.bottom = viewport.top + jWindow.height();

		var bounds = this.offset();
		bounds.right = bounds.left + this.outerWidth();
		bounds.bottom = bounds.top + this.outerHeight();

		return ( !( viewport.right < bounds.left ||
					viewport.left > bounds.right ||
					viewport.bottom < bounds.top ||
					viewport.top > bounds.bottom
				));
	};

	/* smartresize
	================================================== */
	(function($,sr){

		// debouncing function from John Hann
		// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
		var debounce = function (func, threshold, execAsap) {
			var timeout;

			return function debounced () {
				var obj = this, args = arguments;
				function delayed () {
						if (!execAsap)
								func.apply(obj, args);
						timeout = null;
				};

				if (timeout)
						clearTimeout(timeout);
				else if (execAsap)
						func.apply(obj, args);

				timeout = setTimeout(delayed, threshold || 100);
			};
		}
		// smartresize 
		jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
	})(jQuery,'smartresize');
}(jQuery));